import { API } from "aws-amplify";
import { useCreateApiCall } from "hooks/useCreateApiCall";
import { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { setNewMessages } from "store/reducers/newMessagesReducer";

const NEW_MESSAGES_CHECK_INTERVAL_IN_MS = 10000;

export const useMessageIndicator = ({ role }) => {
  const dispatch = useAppDispatch();
  const { createApiCall } = useCreateApiCall();

  const setNewMessagesNumber = (number) => dispatch(setNewMessages(number));

  const loadData = createApiCall(
    async () => {
      const result = await API.post("restApiV2", "/messages/new/count", {
        body: {
          dashboardAccessToken: null,
        },
      });

      if (result?.error) {
        console.error(result.error);
        return;
      }
      setNewMessagesNumber(result?.quantity ?? 0);
    },
    (error) => {
      console.error(error);
    },
    true
  );

  useEffect(() => {
    const isNotSuperAdmin = ["Admin", "Marketer", "Scheduler"].includes(role);
    let interval;
    
    if (isNotSuperAdmin) {
      loadData();
      
      interval = setInterval(() => {
        loadData();
      }, NEW_MESSAGES_CHECK_INTERVAL_IN_MS);
    }
    // @ts-ignore
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  return {};
};
